<template>

  <div class="card ">
    <div class="card-content ">
     <div class="component-title" v-html="dataProps.label"></div>
      <span class="helper-text"
        :class="dataValid ? 'green-text' : 'red-text'"
       v-if="dataProps.helperText">
        {{ !dataValid ? dataProps.helperText.d : dataProps.helperText.s}}
      </span>
    <div class="item-row" v-for="(option) in liveSelections" v-bind:key="option.id">

      <div class="col-3">
      <div class="input-field">
      <date-picker
      ref="dp"
        v-if="repeaterType === 'date'"
        :data-disabled="globalDisabled"
        :default-date="option.notes ? option.notes : option.date"
        @date="$_setValues({target:{value:$event.date}}, option.id)"
      >  {{dataProps.label}} </date-picker>
     
      <textarea  v-else
       class="materialize-textarea"
       style="min-height:50px;"
        :disabled="globalDisabled || dataProps.readonly"
        type="text"
        :value="option.notes"
        @input="$_setValues($event, option.id)"
      ></textarea>
        <label v-if="repeaterType !== 'date'">{{dataProps.single_name ? dataProps.single_name : 'item'}}</label>
      </div>
      </div>
      <div class="col-4">
        <button 
        style="margin-top:20px;"
        :disabled="globalDisabled"
        class="btn-floating btn-flat btn-small waves-effect" @click="$_removeIndex(option.id)">
          <i class="material-icons grey-text text-darken-3">
            delete
          </i>
        </button>
      </div>
    </div>
    </div>
    <div class="clear"></div>

    
    <div class="card-action">
      <button 
      :disabled="globalDisabled"
      class="btn waves-effect rounded z-depth-0" @click="$_addOption()">
        Add {{dataProps.single_name ? dataProps.single_name : 'Item'}}
      </button>
    </div>
  </div>
</template>
<script>

import datePicker from '@/components/records/fields/datePicker.component'
import core from '@/functions'
export default {
  name:'fileContents',
  props:{
    globalDisabled:{
      type:Boolean,
    },
    dataValid: {
      type: Boolean,
    },
    repeaterType:{
      type: String,
      default:'textarea'
    },
    dataType:{
      type: String,
      default: 'api'
    },
    dataProps:{
      type:Object,
    }
  },
  components:{
    datePicker
  },
  data(){
    return {
      selections: [],
      values:'',
    }
  },
  computed:{
    computedProperties:{
      get(){
        const structure  = () => {
          return {
            label:'Routes',
            layout:'col s12',
            name:'user',
            readonly:false,
            type:'model_select',
            values:this.dataProps.values && this.dataProps.values.length > 0 ? this.dataProps.values[0].user : '',
          }
        }
        return  structure()
      }
    },
    liveSelections:{
      get(){
        return this.selections
      }
    }
  },
  mounted(){
    if(this.dataType === 'api') {
    this.dataProps.values && this.dataProps.values.length > 0 
        ? this.selections = this.dataProps.values.map(item => {
          let payload = {}
          payload['id'] =  item['id'] ?  item['id'] : Math.floor(Math.random() * 999)
          payload['notes'] = item[this.dataProps.match ? this.dataProps.match  : 'notes']
        //  payload[this.dataProps.match] = item[this.dataProps.match]
          return payload
        })
        : false
    } else {
       this.dataProps.values && this.dataProps.values.length > 0 
        ? this.selections = this.dataProps.values
        : false
    }
   
  },
  methods:{
    $_setUserProps(evt, index){
      let record = this.selections.find(item=> item.id === index)
      record.user  = evt.id
      this.$emit('update', this.selections)
    },
    $_mapOptions(index){
        const structure  = () => {
          return {
            label:'Routes',
            layout:'col s12',
            name:'user',
            readonly:false,
            type:'model_select',
            values:this.dataProps.values && this.dataProps.values.length > 0 ? this.dataProps.values[index].user : '',
          }
        }
        return  structure()
    },
    $_setValues($event,id){
      let record = this.selections.find(item=> item.id === id)
    /*   if (this.dataProps.match) {
        record.message = $event.target.value
      } else  { */
         record.notes = $event.target.value
    /*   } */
    //console.log($event)
      this.$emit('update', this.selections)
    },
    $_removeIndex(index){
      let record = this.selections.findIndex(item=> item.id === index)
      this.selections.splice(record, 1)
      this.$emit('update', this.selections)
    },
    $_setDate(value, index){
      let record = this.selections.find(item=> item.id === index)
      let date = core.dateFormat(value.date, 'MM/DD/YYYY')
      record.date = date
      this.$emit('update', this.selections)
    },
    $_addOption () {
      let payload  = {
        id: Math.floor(Math.random() * 999),
        notes: this.dataProps.entryFieldType && this.dataProps.entryFieldType === 'date' ? core.dateFormat(new Date(), 'MM/DD/YYYY') : '',
        date: new Date(),
        //message: '',
        //judge: ''
      }

      /* condition to emit default date if type is date  */
  

 /*      if (this.dataProps.match && this.dataProps.match !== 'message') {
        payload[this.dataProps.match] = ''
      } else if (this.dataProps.match === 'message'){
        payload['date'] = new Date(),
        payload['message'] = ''
      } else {
        payload['date'] = new Date(),
        payload['notes'] = ''
      } */
      if(!this.$route.name === 'new_record') {
      this.$store.commit('UPDATE_RECORD', {
        id:parseInt(this.$route.params.id),
        prop:'contents',
        data:payload,
      })
      }
      this.selections.push(payload)

      if (this.dataProps.entryFieldType && this.dataProps.entryFieldType === 'date') {
          setTimeout(() => {
       /*      let index = this.selections.findIndex(x => x.id === payload.id)
            this.$refs.dp[index].pickers.date.instance.open() */
//            this.$emit('update', this.selections)
          }, 100);
      }

    }
  }
}
</script>
<style lang="scss" scoped>
.component-title {
    font-size: 20px;
    text-transform: capitalize;
    margin-bottom: 8px;
  }
.card {
  .input-field {
    margin-bottom: 0px;
  }
  .item-row {  
    display: flex;
  .col-3 {
    margin-right:12px;
    width: calc(100% - 32px);
    }
  }
}
.crp {
    margin: 24px 2px 48px;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.09), 0 3px 1px -2px rgba(0, 0, 0, 0.08), 0 1px 5px 0 rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    padding: 13px;
    background: white;
  .item-row {
    display: flex;
    .col-3 {
      margin-right:12px;
      width: 90%;
    }
  }
}

</style>